import { render, staticRenderFns } from "./MemberInfo.vue?vue&type=template&id=86c3e418"
import script from "./MemberInfo.vue?vue&type=script&lang=js"
export * from "./MemberInfo.vue?vue&type=script&lang=js"
import style0 from "./MemberInfo.vue?vue&type=style&index=0&id=86c3e418&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports